import * as React from 'react';
import classNames from 'classnames';

import './Input.scss';

export type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value'> & {
    dataFor?: string;
    onTermChange?: (term: string) => void;
    clearable?: boolean;
    hasWarning?: boolean;
    ref?: React.Ref<HTMLInputElement>;
    warningText?: string;
};

export const Input: React.FunctionComponent<InputProps> = ({
    clearable = false,
    hasWarning = false,
    onTermChange,
    ref,
    warningText = '',
    ...props
}) => {
    const [value, setValue] = React.useState<string>('');

    const onInputChange = (val: string) => {
        setValue(val);
        if (onTermChange) {
            onTermChange(val);
        }
    };

    return (
        <PuppetInput
            clearable={clearable}
            hasWarning={hasWarning}
            ref={ref}
            value={value}
            warningText={warningText}
            onTermChange={onInputChange}
            {...props}
        />
    );
};
Input.displayName = 'Input';

export type PuppetInputProps = InputProps & {
    value: string;
};

export const PuppetInput: React.FunctionComponent<PuppetInputProps> = ({
    className,
    clearable = false,
    dataFor,
    hasWarning = false,
    onTermChange,
    ref,
    style,
    type = 'text',
    value,
    warningText = '',
    ...props
}) => {
    const onInputChange = (val: string) => {
        if (onTermChange) {
            onTermChange(val);
        }
    };

    const showClearButton = clearable && value.length > 0;
    const formGroupClass = classNames('form-group', {
        'has-clear': showClearButton,
        'has-warning': hasWarning,
    });
    const clearButtonClass = classNames('form-control-clear glyphicon glyphicon-remove form-control-feedback', {
        hidden: !showClearButton,
    });

    return (
        <div className="input-group" style={{ width: style?.width }}>
            <div className={formGroupClass}>
                {hasWarning && <span className="help-block input__help-block">{warningText}</span>}
                <input
                    className={classNames('form-control', className)}
                    data-for={dataFor}
                    ref={ref}
                    style={style}
                    type={type}
                    value={value}
                    onChange={ev => onInputChange(ev.target.value)}
                    {...props}
                />
                <span
                    className={clearButtonClass}
                    style={{ cursor: 'pointer', pointerEvents: 'auto', top: 0, zIndex: 10 }}
                    onClick={() => onInputChange('')}
                ></span>
            </div>
        </div>
    );
};
